
        var result = require("!!../../../../../node_modules/css-loader/index.js!./reason-dialog.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/reason/reason-dialog/reason-dialog.component.css
// module id = 772
// module chunks = 0